import * as React from "react"
import { IconProps } from "./IconProps"

export const OrderIcon = (props: IconProps) => {
  const { color = "currentColor" } = props

  return (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3667 7.66683C10.8667 7.66683 11.3067 7.3935 11.5334 6.98016L13.9201 2.6535C14.1667 2.2135 13.8467 1.66683 13.3401 1.66683H3.47341L2.84675 0.333496H0.666748V1.66683H2.00008L4.40008 6.72683L3.50008 8.3535C3.01341 9.24683 3.65341 10.3335 4.66675 10.3335H12.6667V9.00016H4.66675L5.40008 7.66683H10.3667ZM4.10675 3.00016H12.2067L10.3667 6.3335H5.68675L4.10675 3.00016ZM4.66675 11.0002C3.93341 11.0002 3.34008 11.6002 3.34008 12.3335C3.34008 13.0668 3.93341 13.6668 4.66675 13.6668C5.40008 13.6668 6.00008 13.0668 6.00008 12.3335C6.00008 11.6002 5.40008 11.0002 4.66675 11.0002ZM11.3334 11.0002C10.6001 11.0002 10.0067 11.6002 10.0067 12.3335C10.0067 13.0668 10.6001 13.6668 11.3334 13.6668C12.0667 13.6668 12.6667 13.0668 12.6667 12.3335C12.6667 11.6002 12.0667 11.0002 11.3334 11.0002Z"
        fill={color}
      />
    </svg>
  )
}
